const TickerLine = ({ comment, image, name, showSeparator }) => (

  <div className='flex items-center gap-10'>
    <div
      dir='rtl'
      className='h-20 bg-secondary rounded-custom-16 flex items-center w-[56rem]'
    >
      <img
        src={image || "global_Images/user.png"}
        alt='User'
        className='rounded-custom-16 min-w-[5rem] h-full object-cover'
      />
      <p className='text-3xl font-custom-600 truncate p-4'>
        {/* <p className='text-2xl font-custom-400 text-primary'>{name}</p> */}
        {comment}
      </p>
    </div>
    {showSeparator && (
      <div className='bg-primary h-20 rounded-custom-16 w-[12rem] me-10'></div>
    )}
  </div>
);

export default TickerLine;

// const FirstLine = ({ comment, image }) => (
//   <div className='grid grid-cols-1 laptopS:grid-cols-6 gap-10 pl-10'>
//     <div className='laptopS:col-span-1 bg-primary h-20 rounded-custom-16 w-[12rem]'></div>

//     <div
//       dir='rtl'
//       className='laptopS:col-span-4 h-20 bg-secondary  rounded-custom-16  flex items-center w-[56rem]'
//     >
//       <img
//         src={image || "https://via.placeholder.com/50"}
//         alt='User'
//         className='rounded-custom-16 w-[5rem] h-full object-cover'
//       />
//       <p className='me-10 text-3xl font-custom-600 truncate p-4'>
//         {comment}
//       </p>
//     </div>

//     <div className='laptopS:col-span-1 bg-primary2 h-20 rounded-custom-16 w-[12rem]'></div>
//   </div>
// );

// const Midline = ({ comment1, comment2, image1, image2 }) => (
//   <div dir='rtl' className='grid grid-cols-1 laptopS:grid-cols-6 gap-10 px-10'>
//     <div  className='laptopS:col-span-3 h-20 bg-secondary  rounded-custom-16 flex items-center w-[40.625rem]'>
//       <img
//         src={image1}
//         alt='User'
//         className='rounded-custom-16 w-[5rem] h-full object-cover'
//       />
//       <p className='ms-10 text-3xl font-custom-600'>{comment1}</p>
//     </div>

//     <div className='laptopS:col-span-1 bg-primary h-20 rounded-custom-16 w-[11.875rem]'></div>

//     <div className='laptopS:col-span-2 h-20 bg-secondary  rounded-custom-16 flex items-center w-[26.3125rem]'>
//       <img
//         src={image2}
//         alt='User'
//         className='rounded-custom-16 w-[5rem] h-full object-cover'
//       />
//       <p className='ms-10 text-3xl font-custom-600'>{comment2}</p>
//     </div>
//   </div>
// );
